import {useState} from 'react'
import SewaClientList from '../components/List/SewaClient'
import AirClientList from '../components/List/AirClinetList';


const ClientList = () =>{

  const [type,setType] = useState('')

  return(
    <div className='mt-5'>
     <label className="mb-3">Chose Client Type </label>
      <select className="mb-2 border w-full py-2 px-3 rounded-lg" onChange={(e)=>setType(e.target.value)}>
        <option value=''>--Chose Client Type--</option>
        <option value='sewa' >Sewa</option>
        <option value='air'>Air</option>
      </select>

      { type === 'sewa' && <SewaClientList/>}
      { type === 'air' && <AirClientList/>}

    </div>
  );
}
export default ClientList;